import { PUSH_COMMENT_SUCCESS } from './actiontypes';

import { base } from '../connection';

import { fetch, set, push, fetchOrderByChild, fetchOrderByKey, fetchOrderByValue } from '../helper/firebaseFunctions';


export function setcitydata(user,city, siteId) {
	console.log(new Date());
	return (dispatch) => {
		updateCity(user,city, siteId);
	}
}

function updateCity(user,city, siteId) {
	let userphone = user;
	if(!siteId) return;
	set(`/delivery/webPortal/sites/${siteId}/city_D`,city)
	.then(data => {
		console.log("DONE");
	})
	.catch(error=>{
		console.log(error);
	})
}